import { Box, Divider, Text } from "@chakra-ui/react";
import { SectionTitle } from "../CreditsBoxes/SectionTitle";
import SectionFontsUrlsBox from "../CreditsBoxes/SectionFontsUrlsBox";
import PageTitle from "../CreditsBoxes/PageTitle";
import SectionSoundsUrlsBox from "../CreditsBoxes/SectionSoundsUrlsBox";
import { SectionDependenciesUrlsBox } from "../CreditsBoxes/SectionDependenciesUrlsBox";
import { Spacing } from "../Utils/Calligraphy";
import { Strings } from "../Utils/Strings";
import { useEffect } from "react";

export const Credits = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      marginTop={"10vh"}
      marginX={Spacing.Padded}
    >
      <PageTitle />
      <Divider marginBottom={"4vh"} />

      <SectionTitle text="Fonts" />
      <SectionFontsUrlsBox />

      <SectionTitle text="Sounds" />
      <SectionSoundsUrlsBox />

      <SectionTitle text="Development Dependencies" />
      <SectionDependenciesUrlsBox />

      <Box h ="20vh"/>
      <Divider/>
      <Text textAlign={Spacing.TextAlignCenter}>{Strings.CreditsFooterNote}</Text>
      <Box h ="10vh"/>
    </Box>
  );
};
